import { gql } from 'apollo-angular';

export const TANKER_LINEUP_REPORT_QUERY = gql`
  query TankerLineupReport($portUuid: UUID) {
    tankerLineupReport(portUuid: $portUuid) {
      code
      extras
      fieldsErrors
      message
      status
      data {
        eta
        etb
        etd
        nor
        portName
        productName
        quantity
        supplierName
        tenderNo
        vesselName
        portUuid
      }
    }
  }
`;
